import { c as _c } from "react/compiler-runtime";
import WordDiff from './word-diff';
type InlineEditPairProps = {
  current: string;
  suggested: string;
  label?: string;
};
const InlineEditPair = t0 => {
  const $ = _c(8);
  const {
    current,
    suggested,
    label
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = label && <span className="text-tertiary shrink-0">{label}:</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== current || $[3] !== suggested) {
    t2 = <WordDiff current={current} suggested={suggested} />;
    $[2] = current;
    $[3] = suggested;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex items-baseline gap-1.5 flex-wrap text-caption-3">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default InlineEditPair;